import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { JsonApiDatastore, JsonApiDatastoreConfig } from 'angular2-jsonapi'
import { CookieService } from 'ngx-cookie-service'

import { environment } from '../../environments/environment'
import { Bandeira } from './collect/bandeira.model'
import { EmpresaQueVendeComCartoes } from './collect/empresa-que-vende-com-cartoes.model'
import { Agente } from './collect/estabelecimento/agente.model'
import { Estabelecimento } from './collect/estabelecimento/estabelecimento.model'
import { Exportacao } from './collect/exportacao.model'
import { ExtratoDeAntecipacoes } from './collect/extrato/extrato-de-antecipacoes.model'
import { ExtratoDeRecebimentos } from './collect/extrato/extrato-de-recebimentos.model'
import { ExtratoDeVendas } from './collect/extrato/extrato-de-vendas.model'
import { OperadoraDeMaquina } from './collect/operadora-de-maquina.model'
import { Binario } from './core/binario.model'
import { Configuracao } from './core/configuracao/configuracao.model'
import { TipoDeConfiguracao } from './core/configuracao/tipo-de-configuracao.model'
import { Empresa } from './core/empresa.model'

import { Ocorrencia } from './core/ocorrencia.model'
import { Operador } from './core/operador.model'
import { TipoDeOcorrencia } from './core/tipo-de-ocorrencia.model'

@Injectable()
@JsonApiDatastoreConfig({
    baseUrl: environment.collectJsonApiBaseUrl,
    models: {
        empresas: Empresa,
        operadores: Operador,
        configuracoes: Configuracao,
        ocorrencias: Ocorrencia,
        'tipos-de-ocorrencia': TipoDeOcorrencia,
        binarios: Binario,
        'tipos-de-configuracao': TipoDeConfiguracao,
        'extratos-de-vendas': ExtratoDeVendas,
        'extratos-de-recebimentos': ExtratoDeRecebimentos,
        'extratos-de-antecipacoes': ExtratoDeAntecipacoes,
        'empresas-que-vendem-com-cartoes': EmpresaQueVendeComCartoes,
        'operadoras-de-maquina': OperadoraDeMaquina,
        exportacoes: Exportacao,
        estabelecimentos: Estabelecimento,
        agentes: Agente,
        bandeiras: Bandeira,
    },
})
export class PkwDatastore extends JsonApiDatastore {
    constructor(http: HttpClient, private cookieService: CookieService) {
        super(http)
    }

    protected buildHeaders(customHeaders?: Headers) {
        if (!customHeaders) {
            customHeaders = new Headers()
        }

        const jwt = this.cookieService.get('jwt')
        customHeaders.set('Authorization', `Bearer ${jwt}`)

        return super.buildHeaders(customHeaders)
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/pkw-datastore.ts